import { InputBase, InputBaseProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export const MessageInput = ({ placeholder, ...otherInputProps }: InputBaseProps) => {
  const { t } = useTranslation(I18nNamespace.conversation, { keyPrefix: 'ConversationInput' });
  return (
    <InputBase
      placeholder={placeholder ?? t('placeholder')}
      {...otherInputProps}
      fullWidth
      size="medium"
      type="text"
      name="message"
      autoComplete="off"
      multiline={true}
      maxRows={4}
    />
  );
};
